import { useContext, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsCheckLg } from 'react-icons/bs';
import PropTypes from 'prop-types';

import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import { putApproveDailyWorkReports } from '../../../../../services/workReport';
import ConditionalWrapper from '../../../../ConditionalWrapper/ConditionalWrapper';
import LoaderContext from '../../../../../context/LoaderProvider';
import useToast from '../../../../../hooks/useToast';
import './AcceptButton.scss';

const AcceptButton = ({ dailyWorkReport, fetchData, selectedDate }) => {
  const [disabledButton, setDisableButton] = useState(false);
  const { setNewToast } = useToast();
  const selectedDateFormated = new Date(selectedDate);
  const today = new Date();
  const todayOlderThanSelectedDate = today < selectedDateFormated;
  const { setLoader } = useContext(LoaderContext);

  const AcceptQuantity = async () => {
    try {
      setLoader(true);
      setDisableButton(true);
      const response = await putApproveDailyWorkReports('v1', [dailyWorkReport?.idParteDiario]);

      setNewToast({
        type: 'SUCCESS',
        message: response.mensaje
      });
      fetchData();
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    } finally {
      setDisableButton(false);

      setLoader(false);
    }
  };

  return (
    <ConditionalWrapper
      condition={todayOlderThanSelectedDate}
      wrapper={(children) => (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={<Tooltip id="approve-approver">Linea con fecha posterior a la actual</Tooltip>}
          placement="top"
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <div>
        <div className="action-button-container">
          <button
            aria-label="Aprobar"
            className="accept-button"
            disabled={disabledButton || todayOlderThanSelectedDate}
            onClick={() => AcceptQuantity()}
            type="button"
          >
            <BsCheckLg size={12} />
          </button>
        </div>
      </div>
    </ConditionalWrapper>
  );
};

export default AcceptButton;

AcceptButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport,
  fetchData: PropTypes.func,
  selectedDate: PropTypes.string.isRequired
};

AcceptButton.defaultProps = {
  dailyWorkReport: {},
  fetchData: () => {}
};
